import { takeLatest } from 'redux-saga';
import { all, call, put, select } from 'redux-saga/effects';
import { getJSON } from '../util';


function* fetchPrice({ payload: upc }) {
    const [ api, params ] = yield all([
        select(state => state.api.host),
        select(state => state.api.params),
    ]);
    const price = yield call(getJSON, `${api}/commerce/price/${upc}`,  params);
    if (price.usd && price.usd.voucher_upc) {
        let vparams = {partner: params.partner, key: params.key};
        vparams.upc = price.usd.voucher_upc;
        vparams.site = params.partner;
        vparams.placement = 'text-teeup-message';
        const promo = yield call(getJSON, `${api}/rules/voucher-ownership/promo`,  vparams);
        if (promo && promo[0].message) {
            price.usd.message = promo[0].message;
            price.kc.message = promo[0].message;
        }
    }
    yield put({
        type: 'product:price',
        payload: price,
    });
}

export function* root() {
    yield takeLatest('price:required', fetchPrice);
}



// WEBPACK FOOTER //
// ./app/sagas/price.js